import React from 'react';
import dynamic from 'next/dynamic';

const BoardBuilder = dynamic(
  () => {
    return import('@components/pages/BoardBuilder');
  },
  { ssr: false },
);

export default function BoardBuilderPage() {
  return (
    <>
      <style>
        {`
          *,
          *:before,
          *:after {
              box-sizing: border-box;
          }

          body {
            overflow: hidden;
            display: flex;
            flex-direction: column;
          }
        `}
      </style>
      <BoardBuilder />
    </>
  );
}
